<template>
  <div class="ps-installer-actions" :class="{ 'ps-installer-actions--center': center }">
    <div v-if="$slots.message" class="ps-installer-actions__message">
      <slot name="message" />
    </div>

    <div class="ps-installer-actions__bar">
      <div v-if="$slots.start" class="ps-installer-actions__start">
        <slot name="start" />
      </div>

      <div class="ps-installer-actions__end">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstallerActions',
  props: {
    center: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.ps-installer-actions {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}

.ps-installer-actions__message {
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.ps-installer-actions__bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.ps-installer-actions__start,
.ps-installer-actions__end {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.ps-installer-actions__end {
  margin-left: auto;
}

.ps-installer-actions--center .ps-installer-actions__bar {
  justify-content: center;
}

.ps-installer-actions--center .ps-installer-actions__end {
  margin-left: 0;
}

:global(.dark) .ps-installer-actions {
  border-top-color: #334155;
}

@media (max-width: 639px) {
  .ps-installer-actions__bar {
    flex-direction: column;
    align-items: stretch;
  }

  .ps-installer-actions__start,
  .ps-installer-actions__end {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .ps-installer-actions__end {
    margin-left: 0;
  }

  .ps-installer-actions__start:empty {
    display: none;
  }

  .ps-installer-actions__start :deep(.ps-installer-btn),
  .ps-installer-actions__end :deep(.ps-installer-btn) {
    width: 100%;
  }
}
</style>
